import React from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";

interface TextareaProps {
  id?: string;
  name?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  className?: string;
  fieldClassName?: string;
  error?: string;
  label?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  rows?: number;
  cols?: number;
  autoResize?: boolean;
  maxLength?: number;
}

export function Textarea({
  id,
  name,
  value,
  placeholder,
  disabled = false,
  required = false,
  className,
  fieldClassName,
  error,
  label,
  onChange,
  onBlur,
  onKeyDown,
  rows,
  cols,
  autoResize,
  maxLength,
}: TextareaProps) {
  const inputId = id || name;

  return (
    <div className={classNames("field", fieldClassName)}>
      {label && (
        <label htmlFor={inputId} className="block mb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <InputTextarea
        id={inputId}
        name={name}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        rows={rows}
        cols={cols}
        autoResize={autoResize}
        maxLength={maxLength}
        className={classNames("w-full", { "p-invalid": error }, className)}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
      {error && <small className="p-error block mt-1">{error}</small>}
    </div>
  );
}
